import Vue from "vue";
import VueRouter from "vue-router";
// import HomeView from '../views/HomeView.vue'
import PCHome from "@/views/pc/home.vue";
import MHome from "@/views/m/home.vue";

import { IsPC as IsPC } from "@/utils/util";

Vue.use(VueRouter);

const routes_pc = [
  {
    path: "*",
    redirect: "/",
  },
  {
    path: "/launchPage",
    name: "LaunchPage",
    component: () => import("@/views/pc/launchPage.vue"),
  },

  {
    path: "/",
    name: "PCHome",
    component: PCHome,
    children: [
      {
        path: "/",
        name: "Index",
        component: () => import("@/views/pc/index.vue"),
        meta: { title: "大国工匠" },
      },
      {
        path: "/login",
        name: "login",
        component: () => import("@/views/pc/login.vue"),
        meta: {
          title: "登录",
          topState: true,
        },
      },
      {
        path: "/register",
        name: "register",
        component: () => import("@/views/pc/register.vue"),
        meta: {
          title: "注册",
          topState: true,
        },
      },
      {
        path: "/userCenter",
        name: "UserCenter",
        component: () => import("@/views/pc/userCenter.vue"),
        meta: {
          title: "用户中心",
          topState: true,
        },
      },
      {
        path: "/teacherList",
        name: "TeacherList",
        component: () => import("@/views/pc/teacherList.vue"),
        meta: { title: "大国工匠" },
      },
      {
        path: "/teacherInfo",
        name: "TeacherInfo",
        component: () => import("@/views/pc/teacherInfo.vue"),
        meta: { title: "大国工匠" },
      },
      {
        path: "/courseList",
        name: "CourseList",
        component: () => import("@/views/pc/courseList.vue"),
        meta: { title: "课程专区" },
      },
      {
        path: "/courseInfo",
        name: "CourseInfo",
        component: () => import("@/views/pc/courseInfo.vue"),
        meta: { title: "大国工匠" },
      },
      {
        path: "/courseVideo",
        name: "CourseVideo",
        component: () => import("@/views/pc/courseVideo.vue"),
        meta: { title: "大国工匠" },
      },
      {
        path: "/rankList",
        name: "RankList",
        component: () => import("@/views/pc/rankList.vue"),
        meta: { title: "学习积分" },
      },
      {
        path: "/studentList",
        name: "StudentList",
        component: () => import("@/views/pc/studentList.vue"),
        meta: { title: "大国工匠" },
      },
      {
        path: "/studentInfo",
        name: "StudentInfo",
        component: () => import("@/views/pc/studentInfo.vue"),
        meta: { title: "大国工匠" },
      },
      {
        path: "/clearinghouse",
        name: "Clearinghouse",
        component: () => import("@/views/pc/clearinghouse.vue"),
        meta: { title: "交流中心" },
      },
      {
        path: "/messageList",
        name: "MessageList",
        component: () => import("@/views/pc/messageList.vue"),
        meta: { title: "消息通知" },
      },
      {
        path: "/messageInfo",
        name: "MessageInfo",
        component: () => import("@/views/pc/messageInfo.vue"),
        meta: { title: "消息通知" },
      },
      {
        path: "/activityList",
        name: "ActivityList",
        component: () => import("@/views/pc/activityList.vue"),
        meta: { title: "活动简报" },
      },
      {
        path: "/activityInfo",
        name: "ActivityInfo",
        component: () => import("@/views/pc/activityInfo.vue"),
        meta: { title: "活动简报" },
      },
      {
        path: "/innovateList",
        name: "Innovate",
        component: () => import("@/views/pc/innovateList.vue"),
        meta: { title: "创新公关" },
      },
      {
        path: "/innovateInfo",
        name: "InnovateInfo",
        component: () => import("@/views/pc/innovateInfo.vue"),
        meta: { title: "创新公关" },
      },
      {
        path: "/wcGjxList",
        name: "WcGjxList",
        component: () => import("@/views/pc/wcGjxList.vue"),
        meta: { title: "大国工匠创意工具箱文创设计" },
      },
      {
        path: "/wcGjxList2",
        name: "WcGjxList2",
        component: () => import("@/views/pc/wcGjxList2.vue"),
        meta: { title: "大国工匠创意工具箱文创设计" },
      },
      {
        path: "/wcGjxInfo",
        name: "WcGjxInfo",
        component: () => import("@/views/pc/wcGjxInfo.vue"),
        meta: { title: "大国工匠创意工具箱文创设计" },
      },
      {
        path: "/microCourseList",
        name: "MicroCourseList",
        component: () => import("@/views/pc/microCourseList.vue"),
        meta: { title: "热点话题" },
      },
      {
        path: "/microCourseInfo",
        name: "MicroCourseInfo",
        component: () => import("@/views/pc/microCourseInfo.vue"),
        meta: { title: "热点话题" },
      },
      {
        path: "/microCourseVideo",
        name: "MicroCourseVideo",
        component: () => import("@/views/pc/microCourseVideo.vue"),
        meta: { title: "热点话题" },
      },
      {
        path: "/mienList",
        name: "MienList",
        component: () => import("@/views/pc/mienList.vue"),
        meta: { title: "风采展示" },
      },
      {
        path: "/mienInfo",
        name: "MienInfo",
        component: () => import("@/views/pc/mienInfo.vue"),
        meta: { title: "风采展示" },
      },
      {
        path: "/downloadList",
        name: "DownloadList",
        component: () => import("@/views/pc/downloadList.vue"),
        meta: { title: "通知公告" },
      },
    ],
  },
];
const routes_m = [
  {
    path: "*",
    redirect: "/",
  },
  {
    path: "/launchPage",
    name: "LaunchPage",
    component: () => import("@/views/m/launchPage.vue"),
    meta: { title: "大国工匠人才培育工程" },
  },
  {
    path: "/",
    component: MHome,
    children: [
      {
        path: "/",
        name: "Index",
        component: () => import("@/views/m/index.vue"),
        meta: { title: "大国工匠人才培育工程" },
      },
      {
        path: "/login",
        name: "Login",
        component: () => import("@/views/m/login.vue"),
        meta: { title: "登录" },
      },
      {
        path: "/forgetPass",
        name: "ForgetPass",
        component: () => import("@/views/m/forgetPass.vue"),
        meta: { title: "忘记密码" },
      },
      {
        path: "/register",
        name: "Register",
        component: () => import("@/views/m/register.vue"),
        meta: { title: "注册" },
      },
      {
        path: "/userInfo",
        name: "UserInfo",
        component: () => import("@/views/m/userInfo.vue"),
        meta: { title: "人才培育" },
      },
      {
        path: "/userCenter",
        name: "UserCenter",
        component: () => import("@/views/m/userCenter.vue"),
        meta: { title: "个人中心" },
      },
      {
        path: "/userData",
        name: "UserData",
        component: () => import("@/views/m/userData.vue"),
        meta: { title: "个人中心" },
      },
      {
        path: "/updateSchool",
        name: "UpdateSchool",
        component: () => import("@/views/m/updateSchool.vue"),
        meta: { title: "个人中心" },
      },
      {
        path: "/updatePassword",
        name: "UpdatePassword",
        component: () => import("@/views/m/updatePassword.vue"),
        meta: { title: "个人中心" },
      },
      {
        path: "/authentication",
        name: "authentication",
        component: () => import("@/views/m/authentication.vue"),
        meta: { title: "个人中心" },
      },
      {
        path: "/rankList",
        name: "RankList",
        component: () => import("@/views/m/rankList.vue"),
        meta: { title: "学习积分" },
      },
      {
        path: "/courseList",
        name: "CourseList",
        component: () => import("@/views/m/courseList.vue"),
        meta: { title: "课程专区" },
      },
      {
        path: "/courseInfo",
        name: "CourseInfo",
        component: () => import("@/views/m/courseInfo.vue"),
        meta: { title: "大国工匠" },
      },
      {
        path: "/courseVideo",
        name: "CourseVideo",
        component: () => import("@/views/m/courseVideo.vue"),
        meta: { title: "大国工匠" },
      },
      {
        path: "/courseMy",
        name: "CourseMy",
        component: () => import("@/views/m/courseMy.vue"),
        meta: { title: "大国工匠" },
      },
      {
        path: "/microCourseMy",
        name: "microCourseMy",
        component: () => import("@/views/m/microCourseMy.vue"),
        meta: { title: "大国工匠" },
      },
      {
        path: "/clearinghouse",
        name: "Clearinghouse",
        component: () => import("@/views/m/clearinghouse.vue"),
        meta: { title: "交流中心" },
      },
      {
        path: "/fileList",
        name: "FileList",
        component: () => import("@/views/m/fileList.vue"),
        meta: { title: "通知公告" },
      },
      {
        path: "/fileInfo",
        name: "FileInfo",
        component: () => import("@/views/m/fileInfo.vue"),
        meta: { title: "通知公告" },
      },
      {
        path: "/myClass",
        name: "MyClass",
        component: () => import("@/views/m/myClass.vue"),
        meta: { title: "通知公告" },
      },
      {
        path: "/messageList",
        name: "MessageList",
        component: () => import("@/views/m/messageList.vue"),
        meta: { title: "消息通知" },
      },
      {
        path: "/messageInfo",
        name: "MessageInfo",
        component: () => import("@/views/m/messageInfo.vue"),
        meta: { title: "消息通知" },
      },
      {
        path: "/activityList",
        name: "ActivityList",
        component: () => import("@/views/m/activityList.vue"),
        meta: { title: "活动简报" },
      },
      {
        path: "/activityInfo",
        name: "ActivityInfo",
        component: () => import("@/views/m/activityInfo.vue"),
        meta: { title: "活动简报" },
      },
      {
        path: "/innovateList",
        name: "Innovate",
        component: () => import("@/views/m/innovateList.vue"),
        meta: { title: "创新攻关" },
      },
      {
        path: "/innovateInfo",
        name: "InnovateInfo",
        component: () => import("@/views/m/innovateInfo.vue"),
        meta: { title: "创新攻关" },
      },
      {
        path: "/styleList",
        name: "StyleList",
        component: () => import("@/views/m/styleList.vue"),
        meta: { title: "个人中心" },
      },
      {
        path: "/styleForm",
        name: "StyleForm",
        component: () => import("@/views/m/styleForm.vue"),
        meta: { title: "个人中心" },
      },
      {
        path: "/microCourseList",
        name: "MicroCourseList",
        component: () => import("@/views/m/microCourseList.vue"),
        meta: { title: "热点话题" },
      },
      {
        path: "/microCourseInfo",
        name: "MicroCourseInfo",
        component: () => import("@/views/m/microCourseInfo.vue"),
        meta: { title: "热点话题" },
      },
      {
        path: "/microCourseVideo",
        name: "MicroCourseVideo",
        component: () => import("@/views/m/microCourseVideo.vue"),
        meta: { title: "热点话题" },
      },
      {
        path: "/mienList",
        name: "MienList",
        component: () => import("@/views/m/mienList.vue"),
        meta: { title: "风采展示" },
      },
      {
        path: "/mienInfo",
        name: "MienInfo",
        component: () => import("@/views/m/mienInfo.vue"),
        meta: { title: "风采展示" },
      },
      {
        path: "/collectList",
        name: "CollectList",
        component: () => import("@/views/m/collectList.vue"),
        meta: { title: "点赞和收藏" },
      },
      {
        path: "/wcGjxList",
        name: "WcGjxList",
        component: () => import("@/views/m/wcGjxList.vue"),
        meta: { title: "大国工匠创意工具箱文创设计" },
      },
      {
        path: "/wcGjxList2",
        name: "WcGjxList2",
        component: () => import("@/views/m/wcGjxList2.vue"),
        meta: { title: "大国工匠创意工具箱文创设计" },
      },
      {
        path: "/wcGjxInfo",
        name: "WcGjxInfo",
        component: () => import("@/views/m/wcGjxInfo.vue"),
        meta: { title: "大国工匠创意工具箱文创设计" },
      },
    ],
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes: IsPC() ? routes_pc : routes_m,
});

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

// router.beforeEach((to, from, next)=>{
//   if(to.path == '/'){
//     Vue.prototype.$axios.post("/qz/study/v2/dggj/countdown").then((res) => {
//       if (res.code == 1) {
//         if(res.data > 0){
//           next('/launchPage')
//         }else{
//           next()
//         }
//       }else{
//         next()
//       }
//     });
//   }else{
//     next()
//   }
// })

router.afterEach((to) => {
  if (!IsPC()) {
    let title = to.meta.title;

    if (to.path == "/infoPage") {
      const type = to.query.type;

      if (type == 7 || type == 6) {
        url = "人才培育";
      } else if (type == 5) {
        title = "专题聚焦";
      } else {
        title = "新闻公告";
      }
    }

    document.title = title;
  }
});

export default router;
